var rdv = (function () {
    function get_dt_evenement_data_selectionnes(){
        let table = $('.'+window.TABLE_PARENT+'>tbody').parent().DataTable();
        return table.rows('.selected').data();
    }

    /**
     * clic du bouton du ruban de taj pour ouverture de la modale de création de RDV massif
     */
    function taj_ruban_action_rdv_creation_click(){
        let ids_mun = []
        get_dt_evenement_data_selectionnes().each((e) => {
            ids_mun.push(e.id_municipalite)
        })
        let params = {
         'ids_mun': ids_mun
        }
        $('#modal-generation-rdv').remove();
        $.ajax({
            type: "POST",
            url: "/rdv/tenue-a-jour/rdv-modal-invitations/",
            data: params,
            dataType: 'html',
            success: function (html_response) {
                wait.stop();
                if (html_response) {
                    $('#rapport-taj-include-modals').append(html_response);

                    $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
                    $('#modal-message-background').remove();

                    // Modale
                    var modal_generation_rdv = $('#modal-generation-rdv');
                    $(modal_generation_rdv).modal({
                        show: true,
                        backdrop: 'static'
                    });
                    // event listener bouton de confirmation de génération
                    $('#btn-generation-rdv').off('click').on('click', function () {
                        taj_generation_rdv_massif_click_callback(modal_generation_rdv, TABLE_PARENT);
                    });
                }
            }
        });
    }
    // callback bouton de confirmation de génération
    function taj_generation_rdv_massif_click_callback(modal_generation_rdv, TABLE_PARENT){
        wait.start();
        var uesEvenement = [];
        get_dt_evenement_data_selectionnes().each((e) => {
            if(e.id_ue){
                uesEvenement.push({
                    'id_ue': e.id_ue,
                    'id_evenement': e.id_evenement
                });
            }
        });
        var inspection_en_ligne = ($(modal_generation_rdv).find('#inspection-en-ligne').is(':checked'));
        var inspection_au_domicile = ($(modal_generation_rdv).find('#inspection-au-domicile').is(':checked'));
        var pdf_separe = ($(modal_generation_rdv).find('#exp-pdf-separe').is(':checked'));

        if(!inspection_en_ligne && !inspection_au_domicile){
            alert('Au moins un type de rendez-vous doit être sélectionné');
            wait.stop();
            return false;
        }
        var params = {
            'pdf_separe': pdf_separe,
            'inspection_en_ligne': inspection_en_ligne,
            'inspection_au_domicile': inspection_au_domicile,
            'liste_ues_evenement': JSON.stringify(uesEvenement)
        };
        var table = $('#' + TABLE_PARENT+',.table-evenements').DataTable();
        table.settings.sans_processing = true;
        $.ajax({
            type: "POST",
            url: "/rdv/tenue-a-jour/rdv-generer-invitations/",
            data: params,
            dataType: 'json',
            success: function (response) {
                if(response.lien){
                    window.open(response.lien);
                    infos.ajouterMessageToast({
                        message: 'Un nouvel onglet s\'est ouvert contenant le fichier. ' +
                            'Vous recevrez également un courriel contenant le lien de téléchargement du fichier.',
                        icone: 'fa-envelope-o ',
                        iconeCouleur: 'green',
                        messageDuree: 5000
                    });
                }else{
                    infos.ajouterMessageToast({
                        message: response,
                        icone: 'fa-envelope-o ',
                        iconeCouleur: 'green',
                        messageDuree: 5000
                    });
                }
                refreshDatatables();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.responseText);
                console.log(xhr.status);
                console.log(thrownError);
                infos.ajouterMessageToast({
                    message: xhr.responseText,
                    icone: 'fa-envelope-o ',
                    iconeCouleur: 'red',
                    messageDuree: 5000
                });
                wait.stop();
            }
        });
    }


    // public
    return {
        taj_ruban_action_rdv_creation_click: taj_ruban_action_rdv_creation_click,
    };

})
(); // namespace rdv


